<template>
  <div>
    <div class="all conent">
      <div class="tabs">
        <div class="tab-item tab-item-active">客户备件信息</div>
      </div>
      <div>
        <el-form :inline="true"
                 :model="dataForm"
                 @keyup.enter.native="getDataList(1)"
                 @submit.native.prevent
                 label-width="100px">
          <div class="search-row">
            <div class="search-conent">
              <el-form-item label="物品编码：">
                <el-input v-model="dataForm.goodsCode"
                          placeholder="物品编码"
                          clearable></el-input>
              </el-form-item>
            </div>
            <div class="search-conent">
              <el-form-item label="物品名称：">
                <el-input v-model="dataForm.goodsName"
                          placeholder="物品名称"
                          clearable></el-input>
              </el-form-item>
            </div>
            <div class="search-but">
              <button class="info-but"
                      @click="getDataList(1)">查询</button>
            </div>
          </div>
          <div class="search-row">
            <div class="search-conent">
              <el-form-item label="物品规格：">
                <el-input v-model="dataForm.specification"
                          placeholder="物品规格"
                          clearable></el-input>
              </el-form-item>
            </div>
            <div class="search-conent">
              <el-form-item label="物品型号：">
                <el-input v-model="dataForm.model"
                          placeholder="物品型号"
                          clearable></el-input>
              </el-form-item>
            </div>
            <div class="search-but">
              <button class="info-but"
                      @click="reset()">重置</button>
            </div>
          </div>
          <!-- <div class="search-row">
            <div class="search-conent">
              <el-form-item label="物品配置：">
                <el-input v-model="dataForm.configuration"
                          placeholder="物品配置"
                          clearable></el-input>
              </el-form-item>
            </div>
          </div> -->
        </el-form>
      </div>
      <!-- <div class="opt-row">
        <div class="opt-left">
          <button class="info-but info-but-new" @click="routerHandle('spareGoodsList')">物品领用清单</button>
        </div>
      </div> -->
      <el-table :data="dataList"
                border
                @selection-change="selectionChangeHandle">
        <el-table-column type="index"
                         header-align="center"
                         align="center"
                         width="50"
                         label="序号"></el-table-column>
        <el-table-column prop="companyName"
                         header-align="center"
                         align="left"
                         label="公司"
                         width="120"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="oldGoodsCode"
                         header-align="center"
                         align="left"
                         label="物品编码"
                         width="100"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="oldGoodsName"
                         header-align="center"
                         align="left"
                         label="物品名称"
                         width="120"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="oldSpecification"
                         header-align="center"
                         align="left"
                         label="规格"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="oldModel"
                         header-align="center"
                         align="left"
                         label="型号"
                         show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="oldConfiguration"
                         header-align="center"
                         align="center"
                         label="配置"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="oldEdition"
                         header-align="center"
                         align="center"
                         label="版本"
                         show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="oldBrand"
                         header-align="center"
                         align="center"
                         label="品牌"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="price"
                         header-align="center"
                         align="center"
                         label="单价"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="safetystock"
                         header-align="center"
                         align="right"
                         label="备件数量"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="stockQuantity"
                         header-align="center"
                         align="right"
                         label="现存量"
                         show-overflow-tooltip></el-table-column>
        <!-- <el-table-column header-align="center" align="center" width="80" label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="openGoodsList(scope.row)">领用清单</el-button>
              </template>
            </el-table-column> -->
      </el-table>
      <el-pagination  @size-change="sizeChangeHandle"
                      @current-change="currentChangeHandle"
                      :current-page="currentPage"
                      :page-sizes="[10, 20, 50, 100]"
                      :page-size="pageSize"
                      :total="totalPage"
                      layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
      <!-- <div class="doclist-pagination" v-if="dataList.length">
        <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
        <div class="doclist-omit">{{lastOmit}}</div>
        <ul>
          <li :class="item === currentPage?'pageactive':''" v-for="item in pageList" :key="item" @click="changePageTo(item)">{{item}}</li>
        </ul>
        <div class="doclist-omit">{{nextOmit}}</div>
        <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
        <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text" v-model.number="jumpTargetPage">页</div>
        <div class="doclist-jump" @click="jumpFarPage">确定</div>
      </div> -->
      <!-- <el-pagination background
                     style="margin-top:10px;text-align: center;"
                     layout="prev, pager, next, total, jumper, slot"
                     prev-text="上一页"
                     next-text="下一页"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-size="10"
                     :pager-count="5"
                     :total="totalPage"></el-pagination> -->
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      activeStatus: '1',
      selectList: [],
      dataForm: {
        goodsName: '',
        model: '',
        specification: '',
        // configuration: '',
        goodsCode: ''
      },
      dataList: [],
      // 分页
      totalPage: 0,
      currentPage: 1, // 当前页
      pageSize: 10
      // pickerOptions: {
      //   disabledDate(time) {
      //     return time.getTime() >= (Date.now())
      //   }
      // }
    }
  },
  methods: {
    // 跳转领用清单
    openGoodsList (row) {
      this.$router.push({
        name: 'spareGoodsList',
        query: { goodsName: row.oldGoodsName }
      })
    },
    // 多选
    selectionChangeHandle (list) {
      this.selectList = list
    },
    routerHandle (routerName) {
      this.$router.push(routerName)
    },
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`)
      this.getDataList(1)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getDataList()
      // console.log(`当前页: ${val}`)
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.currentPage = val
      this.getDataList()
    },
    getDataList (currentPage = this.currentPage) {
      this.currentPage = currentPage
      let params = {
        page: currentPage,
        limit: 10,
        oldGoodsName: this.dataForm.goodsName,
        oldModel: this.dataForm.model,
        oldGoodsCode: this.dataForm.goodsCode,
        oldSpecification: this.dataForm.specification,
        companyId: localStorage.getItem('defaultCompanyId') !== '' ? localStorage.getItem('defaultCompanyId') : null
        // oldConfiguration: this.dataForm.configuration
      }
      this.$http.post(`/front/order/lclb/receive/stockByOrdinary`, params)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataList = res.data.data || []
            this.totalPage = res.data.count
          } else {
            this.dataList = []
            this.totalPage = 0
          }
        })
        .catch(() => {
          this.dataList = []
        })
    },
    // 清空form
    reset () {
      this.dataForm = {
        model: '',
        goodsName: '',
        goodsCode: '',
        // configuration: '',
        specification: ''
      }
      this.getDataList()
    },
    // 跳转详情
    openDetailHandle (id) {
      this.$router.push({ name: 'spareGetDetail', query: { id: id } })
    }
  },
  mounted () {
    this.getDataList()
  }
}
</script>
<style scoped>
.conent {
  width: 970px;
  padding: 20px 20px;
}
.search-row {
  display: flex;
}
.search-conent {
  min-width: 350px;
  margin-right: 20px;
}
.search-but {
  width: 100%;
  min-width: 200px;
  text-align: right;
}
.opt-row {
  width: 100%;
  display: flex;
  text-align: right;
  margin-bottom: 20px;
}
.opt-right {
  width: 300px;
}
.opt-left {
  width: 100%;
  text-align: left;
}
.info-but {
  background: #ffffff;
  width: 96px;
  height: 40px;
  text-align: center;
  line-height: 38px;
  font-size: 14px;
  color: #1d65a8;
  letter-spacing: 0;
  border: none;
  cursor: pointer;
  user-select: none;
  border: 1px solid #1d65a8;
  margin-right: 10px;
}
.info-but:hover {
  background: #1d65a8;
  color: #ffffff;
}
.info-but-new {
  background: #1d65a8;
  color: #ffffff;
}
.but-file {
  background-color: #ffffff;
  border: none;
}
.demand-desc {
  width: 100%;
  cursor: pointer;
}
.tip {
  max-width: 500px;
  word-wrap: break-word;
  word-break: break-all;
}
.red {
  color: red;
}
.detail-icon {
  cursor: pointer;
}
.detail-icon:hover {
  color: #1d65a8;
}
.tooltip-content {
  width: 60px;
  text-align: center;
  border-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.short-content {
  max-height: 69px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tabs{
  height: 48px;
  margin: 0 69px;
}
.tab-item{
  display: inline-block;
  /* padding: 12px 16px; */
  text-align: center;
  background: #FFFFFF;
  /* box-shadow: inset 0 -1px 0 0 #DDDDDD; */
  /* width: 88px; */
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  letter-spacing: 0;
  margin-right: 24px;
  cursor: pointer;
}
.tab-item-active{
  color: #1D65A8;
  border-bottom: 2px solid #1D65A8;
}
.tab-item-content{
  padding-top: 10px;
}
</style>
